import { inject, Injectable } from '@angular/core';
import { SbDialogService } from '@sb/ui/dialog';
import { take } from 'rxjs';

import { PayrollDialogComponent } from '../payroll/payroll-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class PayrollOnboardingService {
  private dialogService = inject(SbDialogService);

  openDialog(originator = 'onboarding') {
    return this.dialogService
      .setSize('xxl')
      .open(PayrollDialogComponent, { data: { originator } })
      .closed.pipe(take(1));
  }
}
